import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import { hasEmptyRequiredFields } from "Components/optionForm";
import WithModal from "Components/withModal";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { NEW_DOCUMENT_OBJECT_ATTRIBUTE, documentObjectAttributeRequiredFields } from "../constants";
import NodeAttributeCreator from "./nodeAttributeCreator";
import locale from "./nodeAttributeCreatorPanel.locale";
export const SIZES = {
    MODAL_DEFAULT_WIDTH: 700,
    MODAL_DEFAULT_HEIGHT: 407,
    MODAL_HEIGHT: 407
};
function NodeAttributeCreatorPanel(props) {
    const [changes, setChanges] = useState({});
    const [open, setOpen] = useState(props.open);
    const [showRequiredErrors, setShowRequiredErrors] = useState(false);
    const draft = useMemo(() => ({ ...NEW_DOCUMENT_OBJECT_ATTRIBUTE, ...changes }), [changes]);
    const handleResetDraft = useCallback(() => {
        setChanges({});
        setShowRequiredErrors(false);
    }, []);
    useEffect(() => {
        if (props.open) {
            handleResetDraft();
        }
        setOpen(props.open);
    }, [props.open]);
    const handleClose = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    const handleChangeDraft = useCallback((_, fieldName, value) => {
        setShowRequiredErrors(false);
        setChanges(prev => value === get(NEW_DOCUMENT_OBJECT_ATTRIBUTE, fieldName)
            ? omit(prev, fieldName)
            : {
                ...prev,
                [fieldName]: value
            });
    }, []);
    const handleAdd = useCallback(() => {
        if (hasEmptyRequiredFields(draft, documentObjectAttributeRequiredFields)) {
            setShowRequiredErrors(true);
        }
        else if (props.onAdd) {
            props.onAdd({
                ...draft,
                Id: props.generateAttributeId(),
                DocumentObjectId: props.documentObjectId
            });
            props.onClose && props.onClose();
        }
    }, [draft, props.documentObjectId, props.onAdd, props.generateAttributeId, props.onClose]);
    return (React.createElement(WithModal, { show: open, onHide: handleClose, contentClassName: "modal-padding", shadingColor: shadingLightestColor, className: "bg-blur", title: locale.CREATE_ATTRIBUTE, defaultWidth: SIZES.MODAL_DEFAULT_WIDTH, defaultHeight: SIZES.MODAL_DEFAULT_HEIGHT, height: SIZES.MODAL_HEIGHT },
        React.createElement(NodeAttributeCreator, { draft: draft, onChangeDraft: handleChangeDraft, onResetDraft: handleResetDraft, hasChanges: !isEmpty(changes), showRequiredErrors: showRequiredErrors, onAdd: props.onAdd ? handleAdd : undefined })));
}
export default memo(NodeAttributeCreatorPanel);
